<div class="header">
  <a routerLink="/" class="header__logo">
    <span>INA Comunidades</span>
  </a>

  <app-breadcrumb />

  <div class="header__spacer"></div>

  <ng-container *ngIf="isAuthenticated$ | async">
    <app-global-search class="header__search" />

    <div class="header__avatar-container">
      @if (apiConnection.loading()) {
        <mat-spinner class="header__avatar-progress" [diameter]="48" [strokeWidth]="3" aria-label="Cargando datos de la API" />
      }
      <button mat-icon-button class="header__avatar-btn" [matMenuTriggerFor]="userMenu" aria-label="Menú de usuario" [attr.aria-busy]="apiConnection.loading()">
        <span class="header__avatar">{{ getUserInitials() }}<img *ngIf="userFullInfo?.photoUrl" [appAuthenticatedPhoto]="userFullInfo?.photoUrl" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:inherit"></span>
      </button>
    </div>

    <mat-menu #userMenu="matMenu" panelClass="header-mobile-menu">
      <div class="header-mobile-menu__user-info" (click)="$event.stopPropagation()">
        <div class="header-mobile-menu__avatar" style="position:relative;overflow:hidden">{{ getUserInitials() }}<img *ngIf="userFullInfo?.photoUrl" [appAuthenticatedPhoto]="userFullInfo?.photoUrl" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover"></div>
        <div class="header-mobile-menu__details">
          <div class="header-mobile-menu__name">{{ formatUserLabel(userFullInfo) }}</div>
          <div class="header-mobile-menu__community" *ngIf="userFullInfo?.community?.name">
            <mat-icon class="header-mobile-menu__community-icon">church</mat-icon>
            {{ userFullInfo?.community?.name }}
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <button *ngIf="userFullInfo?.isAdmin" mat-menu-item routerLink="/users">
        <mat-icon>manage_accounts</mat-icon>
        <span>Usuarios</span>
      </button>
      <button *ngIf="userFullInfo?.isAdmin" mat-menu-item routerLink="/configuration">
        <mat-icon>settings</mat-icon>
        <span>Configuración</span>
      </button>
      <button mat-menu-item routerLink="/profile">
        <mat-icon>account_circle</mat-icon>
        <span>Mi perfil</span>
      </button>
      <button *ngIf="feedbackAccess.canAccess()" mat-menu-item routerLink="/feedback">
        <mat-icon>feedback</mat-icon>
        <span>Tareas del equipo</span>
      </button>
      <button *ngIf="canViewPermissionsReport()" mat-menu-item routerLink="/permissions-report">
        <mat-icon>policy</mat-icon><span>Roles y permisos</span>
      </button>
      <button mat-menu-item (click)="openAboutDialog()">
        <mat-icon>info</mat-icon>
        <span>Acerca de</span>
      </button>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </mat-menu>
  </ng-container>

  <div class="header__auth-section" *ngIf="!(isAuthenticated$ | async)">
    <button mat-button class="header__login-btn" (click)="login()">Iniciar sesión</button>
  </div>
</div>
